import React, { Component } from 'react'
import { ThePermission } from 'src/containers/ThePermission';
import {
    CRow,
    CCol,
    CButton,
    CForm,
    CTooltip,
    CInputRadio,
    CFormGroup,
    CLabel,
    CCallout,
    CSelect,
    CCard,
    CCardHeader,
    CCardBody,
    CCardFooter,
    CInput,
    CInputGroup,
    CInputGroupAppend,
    CInputGroupText,
    CPopover,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import configs from 'src/appConfigs';
import Select from 'react-select';
import { helps } from 'src/_helpers';
import OUTexport from './OUTexport';

class OUT extends Component {

    constructor(props) {
        super(props);

        this.state = {
            id: '',
            head_text: {},
            from_to: 'employee',
            store_id: '',
            employee_id: '',
            vendor_id: '',
            housing_id: '',
            receiver: '',
            asset_date: new Date(),
            selected_receiver: {},
            employee: {},
            vendor: {},
            housing: {},
            errors: [],
            selected_items: [],
            record: {},
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);
        this.handleChangeSelectItems = this.handleChangeSelectItems.bind(this);
        this.handleChangeItems = this.handleChangeItems.bind(this);
    }

    componentDidMount() {
        this.setState({
            head_text: {
                'employee': 'Bàn Giao cho Nhân Sự',
                'project': 'Bàn Giao cho Mục Tiêu',
                'housing': 'Bàn Giao cho Nhà Đội',
            }
        })
    }

    handleChange(field, e) {
        let fields = this.state;
        fields[field] = e.target.value;
        this.setState({
            [field]: fields[field]
        });
        this.setState({ fields });
    }

    handleChangeSelect(selectedOptions, field) {
        switch (field) {
            case 'employee':
                this.setState({ employee_id: selectedOptions['value'], receiver: selectedOptions['value'] });
                this.setState({ selected_receiver: selectedOptions });
                break;
            case 'project':
                this.setState({ project_id: selectedOptions['value'] });
                break;
            case 'housing':
                this.setState({ housing_id: selectedOptions['value'] });
                break;
            case 'selected_receiver':
                this.setState({ receiver: selectedOptions['value'] });
                break;
            default:
        }
        this.setState({ [[field]]: selectedOptions });
        //console.log(selectedOptions);
    }

    handleChangeSelectItems(selectedOptions, index) {
        const { items } = this.props;
        var selected_items = this.state.selected_items;
        let item = helps.getItemFromArr(items, selectedOptions.value);
        selected_items[index].item_id = selectedOptions.value;
        selected_items[index].dimension = item.dimension;
        selected_items[index].status = item.status;
        this.setState({ selected_items: selected_items });
        //console.log(item);
    }

    handleChangeItems(field, index, e) {
        var selected_items = this.state.selected_items;
        var selected_item = selected_items[index];
        selected_item[[field]] = e.target.value;
        if (field === 'quantity') selected_item[[field]] = parseInt(e.target.value);
        selected_items[index] = selected_item;
        this.setState({ selected_items: selected_items });
        //console.log(selected_items);
    }

    handleSubmit(e) {
        e.preventDefault();
        const { items } = this.props;
        if (this.handleValidation()) {
            let record = {
                id: this.state.id,
                asset_date: this.state.asset_date,
                category_id: this.props.category_id,
                from_to: this.state.from_to,
                state: 'out',
                store_id: this.state.store_id,
                project_id: this.state.project_id,
                vendor_id: this.state.vendor_id,
                employee_id: this.state.employee_id,
                housing_id: this.state.housing_id,
                receiver: this.state.receiver,
                selected_items: this.state.selected_items,
            }
            switch (record.from_to) {
                case 'project':
                    record['employee_id'] = '';
                    record['housing_id'] = '';
                    break;
                case 'housing':
                    record['employee_id'] = '';
                    record['project_id'] = '';
                    break;
                default:
                    record['housing_id'] = '';
                    record['project_id'] = '';
            }
            this.props.handleOut(record);
        } else {
            return false;
        }
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;

        if (helps.isEmpty(this.state.store_id)) {
            formIsValid = false;
            errors["store_id"] = "Vui lòng chọn Kho.";
        }

        if (this.state.from_to === 'employee' && helps.isEmpty(this.state.employee_id)) {
            formIsValid = false;
            errors["employee"] = "Vui lòng chọn Nhân sự.";
        }

        if (this.state.from_to === 'project' && helps.isEmpty(this.state.project_id)) {
            formIsValid = false;
            errors["project"] = "Vui lòng chọn Mục tiêu.";
        }

        if (this.state.from_to === 'housing' && helps.isEmpty(this.state.housing_id)) {
            formIsValid = false;
            errors["housing"] = "Vui lòng chọn Nhà Đội.";
        }

        if (helps.isEmpty(this.state.receiver)) {
            formIsValid = false;
            errors["selected_receiver"] = "Vui lòng chọn Người nhận.";
        }

        if (helps.isEmpty(this.state.selected_items)) {
            formIsValid = false;
            errors["selected_items"] = "Vui lòng thêm danh sách Tài sản.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    addMoreItem() {
        var selected_items = this.state.selected_items;
        selected_items.push({
            item_id: '',
            dimension: '',
            quantity: 1,
            status: 'new_in_use',
        });
        this.setState({ selected_items: selected_items });
        //console.log(selected_items)
    }

    removeItem(index) {
        var selected_items = this.state.selected_items;
        if (index > -1) { // only splice array when item is found
            selected_items.splice(index, 1); // 2nd parameter means remove one item only
        }
        this.setState({ selected_items: selected_items });
        //console.log(selected_items)
    }

    renderItems() {
        const { items } = this.props;
        //console.log(items);
        var item_options = [];
        if (items && items.length > 0) {
            items.map((item) => {
                item_options.push({ value: item.id, label: item.code + ' - ' + item.name });
            });
        }

        var trs = [];
        let selected_items = this.state.selected_items;
        if (!helps.isEmpty(selected_items)) {
            selected_items.map((item, index) => {
                let found_item = helps.getItemFromArr(items, item.item_id);
                let inventory = found_item.inventory ? found_item.inventory : [];
                let found_inventory = helps.getItemFromArr(inventory, this.state.store_id, 'store_id');
                let recent_inventory = 0;
                //console.log(found_item);
                if (!helps.isEmpty(found_inventory)) {
                    recent_inventory = found_inventory.current_inventory;
                }
                let inventory_color = 'danger';
                if (recent_inventory > 0) {
                    inventory_color = 'success';
                }
                let selected_option = {
                    value: found_item.id,
                    label: found_item.name,
                }
                trs.push(
                    <tr key={'item-' + index}>
                        <td style={{ textAlign: 'center' }}>{index + 1}</td>
                        <td>
                            <Select
                                id={"input-items-" + item.id}
                                placeholder="Tài sản ..."
                                options={item_options}
                                value={selected_option}
                                onChange={(choice) => { this.handleChangeSelectItems(choice, index) }}
                            />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <CInput
                                type='text'
                                name='dimension'
                                value={item.dimension}
                                onChange={(e) => { this.handleChangeItems('dimension', index, e) }}
                            />
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <CInputGroup>
                                <CInput
                                    type='number'
                                    name='quantity'
                                    value={item.quantity}
                                    onChange={(e) => { this.handleChangeItems('quantity', index, e) }}
                                />
                                <CInputGroupAppend>
                                    <CPopover content={'Tồn kho hiện tại: ' + recent_inventory}>
                                        <CInputGroupText className={'bg-' + inventory_color + ' text-white'}>
                                            {recent_inventory}
                                        </CInputGroupText>
                                    </CPopover>
                                </CInputGroupAppend>
                            </CInputGroup>

                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <CSelect
                                name='status'
                                value={item.status}
                                onChange={(e) => { this.handleChangeItems('status', index, e) }}
                            >
                                {configs.asset_statuses && configs.asset_statuses.map((status) => {
                                    return (
                                        <option key={index + '-' + status.id} value={status.id}>{status.label}</option>
                                    )
                                })}
                            </CSelect>
                        </td>
                        <td style={{ textAlign: 'center' }}>
                            <CTooltip content={'Xóa: ' + index}>
                                <CButton
                                    type='button'
                                    size='sm'
                                    color="danger"
                                    onClick={() => { this.removeItem(index) }}
                                >
                                    <CIcon name="cil-x" className="mfe-1 mt-0"></CIcon>
                                </CButton>
                            </CTooltip>
                        </td>
                    </tr>
                );
            })
        }
        return trs;
    }

    render() {
        const { employees, vendors, stores, projects, housings } = this.props;
        var employee_options = [];
        if (employees && employees.length > 0) {
            employees.map((employee) => {
                employee_options.push({ value: employee.employee_id, label: employee.fullname + ' (' + employee.employee_id + ')' });
            });
        }
        var vendor_options = [];
        if (vendors && vendors.length > 0) {
            vendors.map((vendor) => {
                vendor_options.push({ value: vendor.id, label: vendor.name });
            });
        }
        var project_options = [];
        if (projects && projects.length > 0) {
            projects.map((project) => {
                project_options.push({ value: project.id, label: project.name });
            });
        }

        var housing_options = [];
        if (housings && housings.length > 0) {
            housings.map((housing) => {
                housing_options.push({ value: housing.id, label: housing.name });
            });
        }

        var filter_date_val = '';
        let asset_date = this.state.asset_date;
        if (this.state.asset_date) {
            if (!helps.isEmpty(asset_date) && typeof asset_date === 'object') {
                filter_date_val = helps.formatDate_for_input(asset_date.toDate(), 'YYYY-MM-DD');
            } else {
                filter_date_val = helps.formatDate_for_input(asset_date, 'YYYY-MM-DD');
            }

        } else {
            filter_date_val = new Date().toISOString().slice(0, 10);
        }

        return (
            <CForm onSubmit={(e) => this.handleSubmit(e)}>
                <CRow>
                    <CCol md={3}>
                        <CCallout color='warning' className='mb-5 pb-3 pt-3'>
                            <CFormGroup variant="custom-radio" inline>
                                <CInputRadio
                                    custom
                                    id={"from_to_employee"}
                                    name="from_to"
                                    value='employee'
                                    checked={this.state.from_to === 'employee'}
                                    onChange={(e) => { this.handleChange('from_to', e) }}
                                />
                                <CLabel variant="custom-checkbox" htmlFor="from_to_employee" className="cursor-pointer font-weight-bold">
                                    {this.state.head_text['employee']}
                                </CLabel>
                            </CFormGroup>
                        </CCallout>
                        <CCallout color='success' className='mb-5 pb-3 pt-3'>
                            <CFormGroup variant="custom-radio" inline>
                                <CInputRadio
                                    custom
                                    id={"from_to_project"}
                                    name="from_to"
                                    value='project'
                                    checked={this.state.from_to === 'project'}
                                    onChange={(e) => { this.handleChange('from_to', e) }}
                                />
                                <CLabel variant="custom-checkbox" htmlFor="from_to_project" className="cursor-pointer font-weight-bold">
                                    {this.state.head_text['project']}
                                </CLabel>
                            </CFormGroup>
                        </CCallout>
                        <CCallout color='info' className='mb-5 pb-3 pt-3'>
                            <CFormGroup variant="custom-radio" inline>
                                <CInputRadio
                                    custom
                                    id={"from_to_housing"}
                                    name="from_to"
                                    value='housing'
                                    checked={this.state.from_to === 'housing'}
                                    onChange={(e) => { this.handleChange('from_to', e) }}
                                />
                                <CLabel variant="custom-checkbox" htmlFor="from_to_housing" className="cursor-pointer font-weight-bold">
                                    {this.state.head_text['housing']}
                                </CLabel>
                            </CFormGroup>
                        </CCallout>
                    </CCol>
                    <CCol md={9}>
                        <CCard>
                            <CCardHeader>
                                {this.state.head_text[this.state.from_to]}
                            </CCardHeader>
                            <CCardBody>
                                <div className='mb-3'>
                                    <div className='mb-3'>
                                        <CRow>
                                            <CCol>
                                                <CLabel htmlFor='input-stores'>Kho:</CLabel>
                                                <CSelect
                                                    id='input-stores'
                                                    onChange={(e) => { this.handleChange('store_id', e) }}
                                                    required
                                                >
                                                    <option value=''> - Chọn Kho - </option>
                                                    {!helps.isEmpty(stores) && stores.map((store) => {
                                                        return (
                                                            <option key={store.id} value={store.id}>{store.name}</option>
                                                        );
                                                    })}
                                                </CSelect>
                                                <small className="text-danger">{this.state.errors['store_id']}</small>
                                            </CCol>
                                            <CCol>
                                                <CLabel htmlFor='asset-date'>Ngày Xuất / Bàn Giao:</CLabel>
                                                <CInput
                                                    type='date'
                                                    id='asset-date'
                                                    name='asset_date'
                                                    value={filter_date_val}
                                                    onChange={(e) => { this.handleChange('asset_date', e) }}
                                                />
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <CRow>
                                        <CCol>
                                            {this.state.from_to === 'employee' && <>
                                                <CLabel htmlFor='input-employees'>Nhân Sự:</CLabel>
                                                <Select
                                                    id="input-employees"
                                                    placeholder="Nhân sự ..."
                                                    options={employee_options}
                                                    value={this.state.employee}
                                                    isClearable={true}
                                                    onChange={(choice) => { this.handleChangeSelect(choice, 'employee') }}
                                                />
                                                <small className="text-danger">{this.state.errors['employee']}</small>
                                            </>}
                                            {this.state.from_to === 'project' && <>
                                                <CLabel htmlFor='input-projects'>Mục tiêu:</CLabel>
                                                <Select
                                                    id="input-projects"
                                                    placeholder="Mục tiêu ..."
                                                    options={project_options}
                                                    value={this.state.project}
                                                    isClearable={true}
                                                    onChange={(choice) => { this.handleChangeSelect(choice, 'project') }}
                                                />
                                                <small className="text-danger">{this.state.errors['project']}</small>
                                            </>}
                                            {this.state.from_to === 'housing' && <>
                                                <CLabel htmlFor='input-housings'>Nhà đội:</CLabel>
                                                <Select
                                                    id="input-housings"
                                                    placeholder="Nhà đội ..."
                                                    options={housing_options}
                                                    value={this.state.housing}
                                                    isClearable={true}
                                                    onChange={(choice) => { this.handleChangeSelect(choice, 'housing') }}
                                                />
                                                <small className="text-danger">{this.state.errors['housing']}</small>
                                            </>}
                                        </CCol>
                                        <CCol>
                                            <CLabel htmlFor='input-receiver'>Người nhận:</CLabel>
                                            <Select
                                                id="input-receiver"
                                                placeholder="Người nhận ..."
                                                options={employee_options}
                                                value={this.state.selected_receiver}
                                                isClearable={true}
                                                onChange={(choice) => { this.handleChangeSelect(choice, 'selected_receiver') }}
                                            />
                                            <small className="text-danger">{this.state.errors['selected_receiver']}</small>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div className='mb-3'>
                                    <div className='mb-3'>
                                        <CRow>
                                            <CCol>
                                                <b>Danh sách tài sản:</b>
                                            </CCol>
                                        </CRow>
                                        <small className="text-danger">{this.state.errors['selected_items']}</small>
                                    </div>
                                    <table class="table table-bordered">
                                        <thead>
                                            <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                                            <th style={{ width: '40%' }}>
                                                Tài sản
                                            </th>
                                            <th style={{ width: '15%', textAlign: 'center' }}>
                                                Kích thước/chủng loại
                                            </th>
                                            <th style={{ width: '15%', textAlign: 'center' }}>
                                                Số lượng
                                            </th>
                                            <th style={{ width: '15%', textAlign: 'center' }}>
                                                Tình trạng
                                            </th>
                                            <th style={{ width: '5%', textAlign: 'center' }}>
                                                X
                                            </th>
                                        </thead>
                                        <tbody>
                                            {this.renderItems()}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colSpan={6} className='text-right'>
                                                    <CTooltip content={'Thêm'}>
                                                        <CButton
                                                            type='button'
                                                            size='sm'
                                                            color="primary"
                                                            onClick={() => { this.addMoreItem() }}
                                                        >
                                                            <CIcon name="cil-plus" className="mfe-1 mt-0"></CIcon>
                                                            Thêm
                                                        </CButton>
                                                    </CTooltip>
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </CCardBody>
                            <CCardFooter>
                                <CRow>
                                    <CCol>
                                        <CTooltip content={'Xuất / Bàn Giao'}>
                                            <CButton type="submit" color="primary">
                                                <CIcon name="cil-save" className="mfe-1 mt-0"></CIcon>
                                                Xuất / Bàn Giao
                                            </CButton>
                                        </CTooltip>
                                    </CCol>
                                    <CCol className={'text-right'}>
                                        <OUTexport {... this.props} data={this.state} />
                                    </CCol>
                                </CRow>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CForm>
        )
    }
}

export default OUT;
